import { Component, OnInit } from '@angular/core';
import { environment } from '../../shared/config/app-config';
import { ActivatedRoute, Resolve,Router, RouterStateSnapshot } from '@angular/router';
import { FormSessionCanDeactivate, UserService } from '../../shared';


@Component({
  templateUrl: 'pdfpage.component.html',
  styleUrls: ['./pdfpage.component.css']
  
  
})

export class PdfpageComponent extends FormSessionCanDeactivate {
  public data: Object;
  documenturl:string = environment.documenturl;
  apiurl:any = environment.api_url;
  type:any
  path:any
  constructor(
    
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService
   
    
  ) {
    super();
  }


  
  
  ngOnInit() {
    this.route.params.subscribe(params => this.type = params);
    
    this.userService
    .getbulletinboard(this.type.type)
    .subscribe(
      data => {
        for(var i=0;i<data.length;i++ ){
          
            if(data[i].bulletinBoardId == this.type.id){
              this.path = data[i].filePath
            }
           
          
        }
        
      }
      
    );
   
  }
  
   
}
  

   
 
  

